var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SamModal',_vm._b({attrs:{"is-open":Boolean(_vm.component)},on:{"close":_vm.handleClose}},'SamModal',_vm.modalProps,false),[(Boolean(_vm.component))?_c(_vm.component,_vm._b({tag:"component",on:{"close":_vm.handleClose}},'component',_vm.props,false)):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }